
const DrawerSelect = ({ id, label, name, value, data, onChange }) => {
    return (
        <div className='form-group mb-3'>
            <label for={id}>{label}</label>
            <select id={id} name={name} value={value} className="form-control" onChange={onChange}>
                {
                    data.map((item, index) => {
                        return <option key={index} value={item}>{item}</option>
                    })
                }
            </select>
        </div>
    )
}

export default DrawerSelect